import { render, staticRenderFns } from "./Law.vue?vue&type=template&id=565f8021&scoped=true"
import script from "./Law.vue?vue&type=script&lang=js"
export * from "./Law.vue?vue&type=script&lang=js"
import style0 from "./Law.vue?vue&type=style&index=0&id=565f8021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565f8021",
  null
  
)

export default component.exports